module.exports = __webpack_public_path__ + "assets/img/img1.dfae81a0.png";